import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import Chart from "react-apexcharts";

export default function EmployeesDepartmentChart() {

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },

    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "35%",
        borderRadius: 6
      }
    },

    colors: ["#f26522"],

    xaxis: {
      categories: [
        "UI/UX",
        "Development",
        "Management",
        "HR",
        "Testing",
        "Marketing"
      ],
      axisBorder: { show: false },
      axisTicks: { show: false }
    },

    yaxis: {
      labels: {
        style: {
          fontSize: "14px"
        }
      }
    },

    grid: {
      borderColor: "#e5e5e5",
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      }
    },

    dataLabels: {
      enabled: false
    },

    tooltip: {
      x: {
        show: true
      },
      y: {
        formatter: (val) => `Employee: ${val}`
      }
    }
  };

  const series = [
    {
      name: "Employees",
      data: [80, 110, 70, 20, 60, 100]
    }
  ];

  return (
    <Card className="flex-fill task-card">

      <Card.Header className="d-flex justify-content-between align-items-center card-header-custom">
        <h5>Employees By Department</h5>

        <Dropdown>
          <Dropdown.Toggle variant="light">
            This Week
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item>This Month</Dropdown.Item>
            <Dropdown.Item>This Week</Dropdown.Item>
            <Dropdown.Item>Last Week</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

      </Card.Header>

      <Card.Body>

        <Chart
          options={options}
          series={series}
          type="bar"
          height={250}
        />

        <p className="mt-1 small">
          <span style={{fontSize:"7px"}} className="text-warning">●</span> No of Employees increased by
          <span  style={{fontSize:"7px"}} className="text-success fw-bold"> +20%</span> from last Week
        </p>

      </Card.Body>
      <style>
        {
          `
          .task-card{
          border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
          }
          
                .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
          @media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}
          `
        }
      </style>

    </Card>
  );
}